import { FeedbackCategory } from '@/types/feedback/FeedbackCategory';

export default function(feedbackCategory: FeedbackCategory | undefined | null): string {
  switch (feedbackCategory) {
    case FeedbackCategory.TOURISMNFEE:
      return 'feedbackCategory.tourismnfee';
    case FeedbackCategory.BENEFITS:
      return 'feedbackCategory.benefits';
    case FeedbackCategory.COMMUNE:
      return 'feedbackCategory.commune';
    case FeedbackCategory.ERROR:
      return 'feedbackCategory.error';
    case FeedbackCategory.SUGGESTION:
      return 'feedbackCategory.suggestion';
    default:
      return 'feedbackCategory.NONE';
  }
}
